module.exports = __webpack_public_path__ + "img/logo_block.d4ac2160.svg";